import { gql } from "@apollo/client";

export interface IAdminDeleteProfileVars {
  profileId: string;
}

export const ADMIN_DELETE_PROFILE = gql`
  mutation adminDeleteProfile($profileId: String!) {
    adminDeleteProfile(profileId: $profileId)
  }
`;
